import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, RouteGuard } from './core/guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
        canActivate: [ RouteGuard ]
      },
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth/login'
      }
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/static/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
